module.exports = __webpack_public_path__ + "img/koi_nmg_xclogo.7866545e.png";